import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import type { Node } from 'react';

export const BackgroundPortal = forwardRef((props, ref): Node => <Portal data-test="background-portal" ref={ref} />);

const Portal = styled('div')(({ theme }) => `
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -10;
  background-color: ${theme.color.white};
`);
